import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the product title block's colour and size line in step with the
 * selected variant. The variant picker only morphs itself; every other block
 * updates from the fetched page carried on the product select event (the
 * same pattern as product-price). Matters on products whose colour is a real
 * option, such as the wood samples.
 *
 * @extends {Component}
 */
class TobsProductTitle extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`tobs-product-title[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        const current = this.querySelector('.tobs-product-title__meta');
        const incoming = next.querySelector('.tobs-product-title__meta');
        if (current && incoming) {
          current.replaceWith(incoming);
        } else if (current) {
          current.remove();
        } else if (incoming) {
          this.querySelector('.tobs-product-title__name')?.insertAdjacentElement('afterend', incoming);
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[tobs-product-title] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('tobs-product-title')) {
  customElements.define('tobs-product-title', TobsProductTitle);
}
